module.exports = __webpack_public_path__ + "static/pfb-logo.f45161a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/pfb-logo.png
// module id = 508
// module chunks = 114276838955818